export const CREATE_PRINT_REQUEST = "CREATE_PRINT_REQUEST"
export const CREATE_PRINT_REQUEST_SUCCESS = "CREATE_PRINT_REQUEST_SUCCESS"


